import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import IntlMessages from 'util/IntlMessages';
import { toggleCollapsedSideNav } from '../../../appRedux/actions/Setting';

const NoHeaderNotification = (props) => {
  const { navCollapsed, toggleCollapsedSideNav } = props;
  return (
    <div className="gx-no-header-horizontal">
      <div className="gx-d-block gx-d-lg-none gx-linebar gx-mr-xs-3">
        <i
          className="gx-icon-btn icon icon-menu"
          onClick={() => {
            toggleCollapsedSideNav(!navCollapsed);
          }}
        />
      </div>
      <div className="gx-no-header-horizontal-top">
        <div className="gx-no-header-horizontal-top-center">
          <i className="icon icon-alert gx-mr-3" />
          <p className="gx-mb-0 gx-text-truncate"><IntlMessages id="app.announced" /></p>
        </div>
      </div>
    </div>
  );
};

NoHeaderNotification.propTypes = {
  navCollapsed: PropTypes.bool,
  toggleCollapsedSideNav: PropTypes.func
};

NoHeaderNotification.defaultProps = {
  navCollapsed: false,
  toggleCollapsedSideNav: () => { }
};

const mapStateToProps = ({ settings }) => {
  const { navCollapsed } = settings;
  return { navCollapsed };
};
export default connect(mapStateToProps, { toggleCollapsedSideNav })(NoHeaderNotification);
